import invert from 'lodash.invert';
import { OrderedSet } from 'immutable';

export const FILTER_KEYS = Object.freeze({
  OWNER: 'owner',
  BUILD: 'build',
  OS: 'os',
  BROWSER: 'browser',
  TAG: 'tag',
  FRAMEWORK: 'framework',
  DEVICE: 'device',
  DEVICE_GROUP: 'deviceGroup',
});

export const OWNER_PARAM_MAP = Object.freeze({
  org: 'org_id',
  user: 'user_id',
  team: 'team_id',
  group: 'group_id',
  owners: 'owners',
});

export const OWNER_PARAM_VALUE_MAP = Object.freeze(invert(OWNER_PARAM_MAP));

export const DEVICE_GROUP_MAP = Object.freeze({
  public: 'public',
  private: 'private',
});

export const FILTER_KEY_MAP = Object.freeze({
  os: 'os',
  build: 'build',
  device: 'device',
  browser: 'browser',
  tag: 'tag',
  framework: 'framework',
  device_group: 'deviceGroup',
});

export const OS_PREFIX_MAP = Object.freeze({
  ANDROID: 'Android',
  IOS: 'iOS',
});

export const DEVICE_GROUP_ITEMS = OrderedSet([
  { name: 'public', label: 'Public' },
  { name: 'private', label: 'Private' },
]);

export const OS_PREFIX_TO_PARAM_MAP = Object.freeze(invert(OS_PREFIX_MAP));
export const FILTER_KEY_TO_PARAM_MAP = Object.freeze(invert(FILTER_KEY_MAP));
